import React, {Component} from 'react';
import s from './Button.css';
import useStyles from "isomorphic-style-loader/useStyles";
import PropTypes from "prop-types";

export default function Button ({ active, onClick }) {
    useStyles(s);

    return (
        <div className={s.root + (active ? ' ' + s.active : '')} onClick={onClick} />
    );
}

Button.propTypes = {
    onClick: PropTypes.func.isRequired
};

